const cc = { // customer config

    maxisu : {

        API_URL : "https://pumpselector.maxisu.com/api/",
        PDF_URL : "https://pumpselector.maxisu.com:9095/pdf",
        CARTPDF_URL : "https://pumpselector.maxisu.com:9095/cart-pdf",
        XLSX_URL : "https://pumpselector.maxisu.com:9095/cart-xlsx",

    }

}

export default cc